module.exports = __webpack_public_path__ + "assets/img/fb9d9afad1ee8b06c04658a7e2984176.png";